import { Outlet } from "react-router-dom";
import { CityProvider } from "@/contexts/CityContext";
import { findCity, getCitySlug } from "@/lib/city";

/**
 * Resolves the current city from the subdomain and injects it via CityProvider.
 * Unknown/inactive cities still render — pages read city.isActive themselves.
 * getCitySlug() falls back to VITE_DEFAULT_CITY_SLUG for local dev.
 */
export function CityLayout() {
  const city = findCity(getCitySlug());
  if (!city) return null;

  return (
    <CityProvider city={city}>
      <Outlet />
    </CityProvider>
  );
}
